import NotesPage from './NotesPage';

export default NotesPage;
